import {Navigate} from "react-router-dom";
// import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import {lazy} from "react";
import MainLayout from "../MainLayout";

const UnauthorizedAccess = Loadable(lazy(() => import('../../utils/ui-components/UnauthorizedAccess')));
const AdminPachages = Loadable(lazy(() => import('../SuperAdmin/Packages')));
const Dashboard = Loadable(lazy(() => import('../Dashboard')));
const CompanyList = Loadable(lazy(() => import('../SuperAdmin/company/company-list')));

function SuperAdminAuthorizedRoutes (user: any){
    return [
        {
            path: "/",
            element: <MainLayout/>,
            children: [
                // {
                //     path: 'dashboard',
                //     element: <Dashboard/>
                // },
                {
                    path: 'admin-packages',
                    element: <AdminPachages/>
                },
                {
                    path: 'admin-company',
                    element: <CompanyList/>
                },
            ]
        },
        {
            path: 'unauthorized',
            element: <UnauthorizedAccess/>
        },
        {
            path: '',
            element: <Navigate to="/admin-packages"/>
        },
        {
            path: 'login',
            element: <Navigate to="/admin-packages"/>
        },
        {
            path: "*",
            element: <Navigate to="/admin-packages"/>
        },
    ];
}

export default SuperAdminAuthorizedRoutes;